import { SpinnerWrapper } from '@repo/ui/components/Icon';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn, FlexContainer } from 'styles/layouts';

export const Card = styled(FlexColumn)`
  height: 100%;
  padding: 24px;
  background: ${themeStyle.varBackgroundAlt};
  border-radius: ${themeStyle.radiusLarge};
  box-shadow: ${themeStyle.shadowSoft};
`;

export const CenteredSpinnerWrapper = styled(SpinnerWrapper)`
  position: absolute;

  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
`;

export const Wrapper = styled(FlexColumn)<{
  background?: string;
}>`
  position: relative;

  align-items: center;
  justify-content: center;

  width: 100%;

  border-radius: ${themeStyle.radiusMedium};
  background: ${themeStyle.varBackgroundBase};
  background-image: ${({ background }) =>
    background ? `url(${background})` : undefined};

  overflow: hidden;

  aspect-ratio: 1 / 1;
  ${QUERIES.largeTabletAndUp} {
    aspect-ratio: auto;
  }
`;

export const ActionWrapper = styled(FlexContainer)<{
  justifyContent: string;
  multiline: boolean;
}>`
  flex-direction: ${({ multiline }) => (multiline ? 'column' : 'row')};
  justify-content: ${({ justifyContent }) => justifyContent};
  gap: ${({ multiline }) => (multiline ? '16px' : '8px')};
`;
